import { Component, OnInit, ViewChild } from '@angular/core';
import { FilesProvider, ImageReadyService } from './providers/';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FileViewBase } from './file.view.directive';
@Component({
  selector: 'file-view-video-native',
  template: `
    <div class="wp-overlay">
      <div class="wp-center">
        <video #wpVideoPlayer width="600" controls autoplay (loadmedtadata)="getSize()">
          <source [src]="url" [type]="file.mime">
        </video>
      </div>
    </div>
  `
})
export class FileViewVideoNativeComponent extends FileViewBase implements OnInit {
  url: SafeResourceUrl;
  @ViewChild('wpVideoPlayer') videoPlayer;
  constructor(public fp: FilesProvider, public irs: ImageReadyService, private san: DomSanitizer) {
    super(fp, irs);
    this.irs.wait();
  }
  ngOnInit() {
    this.url = this.file.view(this.san);
    this.irs.done();
  }

  getSize() {
    let width = this.videoPlayer.nativeElement.videoWidth;
    let height = this.videoPlayer.nativeElement.videoHeight;
    console.log({width, height});
  }
}



// WEBPACK FOOTER //
// ./src/app/file.view.video.ts